<template>
  <div class="button-icon-container">
    <el-tooltip :enterable="false" :content="tooltip" :disabled="!tooltip" placement="top">
      <div>
        <el-button class="el-button--icon" :type="type" :disabled="disabled" @click="onButtonClick">
          <Icon :name="name" />
        </el-button>
      </div>
    </el-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'

type TButtonType = 'default' | 'primary'

export default defineComponent({
  components: { Icon },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    type: {
      type: String as PropType<TButtonType>,
      default: 'default'
    }
  },
  methods: {
    onClick(event: Event) {
      this.$emit('click', event)
      return event
    },
    /**
     * hrefが存在する場合、渡されたURLを新規タブで開く
     */
    onButtonClick(event: Event) {
      if (this.href) {
        // 新規タブを開く際に reverse tabnabbing を防ぐために noopener/noreferrer を付与する
        window.open(this.href, '_blank', 'noopener,noreferrer')
      } else {
        this.onClick(event)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.button-icon-container {
  display: inline-block;
}

.el-button:focus {
  color: $text-color;
  background: #fff;
  border: 1px solid $border-color;
}

.el-button--primary:focus {
  color: #fff;
  background: $primary-color;
  border-color: $primary-color;
}
</style>
